import React from 'react';
import {Box, Container, Stack} from '@mui/material';

const Banner = props=>{
    let {image, placeholderColor, backgroundPosition='75%',
        children, padding, noOverlay, maxWidth='lg', ...rest} = props;
    return <Stack sx={{
        ...placeholderColor&&{backgroundColor: placeholderColor},
        ...image&&{backgroundImage: `url('${image}')`},
        position: 'relative',
        backgroundAttachment: 'fixed',
        backgroundPosition,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        ...padding&&{paddingTop: padding, paddingBottom: padding},
    }} {...rest}>
      {!noOverlay&&<Box sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
      }}></Box>}
      <Stack paddingTop={3} paddingBottom={3} width="100%" sx={{
          color: 'white',
          zIndex: 1,
          textShadow: '0 0 4px black, 4px 4px 4px rgba(0, 0, 0, 0.5)',
      }}>
        <Container maxWidth={maxWidth}>
          <Stack gap={3} direction="column" justifyContent="center" alignItems="center">
            {children}
          </Stack>
        </Container>
      </Stack>
    </Stack>;
};

export default Banner;
